import { Navigate, Route, Routes } from "react-router-dom";
import { publicRoutes, adminRoutes, errorRout } from "./index";
import { useGetCurUserQuery } from "../app/services/auth";
import { useAppSelector } from "../app/hooks/hooks";
import { selectUser } from "../app/features/auth/authSlice";
import LinkPage from "../pages/LinkPage";

const AppRouter = () => {
    const { isLoading } = useGetCurUserQuery();
    const currentUser = useAppSelector(selectUser);
    if (isLoading) {
        return <span>loading</span>;
    }
    return currentUser ? (
        <Routes>
            {currentUser.roles === '["ADMIN"]' &&
                adminRoutes.map((route) => (
                    <Route
                        key={route.path}
                        path={route.path}
                        element={route.element}
                    />
                ))}
            {publicRoutes.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                />
            ))}
            <Route path={errorRout.path} element={errorRout.element} />
            <Route path="/link/:link" element={<LinkPage></LinkPage>} />
            <Route path="*" element={<Navigate to="/files" replace />} />
        </Routes>
    ) : (
        <Routes>
            {publicRoutes.map((route) => (
                <Route
                    key={route.path}
                    path={route.path}
                    element={route.element}
                />
            ))}
            <Route path={errorRout.path} element={errorRout.element} />
            <Route path="/link/:link" element={<LinkPage></LinkPage>} />
            <Route path="*" element={<Navigate to="/demo" replace />} />
        </Routes>
    );
};

export default AppRouter;
